import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { api, unwrap } from '@/shared/api/client';
import { STALE } from '@/shared/api/stale';

import { importKeys } from './keys';

export const importsQuery = () =>
  queryOptions({
    queryKey: importKeys.list(),
    queryFn: ({ signal }) => unwrap(api.GET('/imports', { signal })),
    staleTime: STALE.list,
    placeholderData: keepPreviousData,
  });

export const importQuery = (id: string) =>
  queryOptions({
    queryKey: importKeys.detail(id),
    queryFn: ({ signal }) => unwrap(api.GET('/imports/{importId}', { params: { path: { importId: id } }, signal })),
    staleTime: STALE.record,
  });

export const importStagesQuery = (bankId: string) =>
  queryOptions({
    queryKey: importKeys.stages(bankId),
    queryFn: ({ signal }) => unwrap(api.GET('/banks/{bankId}/stages', { params: { path: { bankId } }, signal })),
    staleTime: STALE.reference,
  });

export const importEmployersQuery = (q: string) =>
  queryOptions({
    queryKey: importKeys.employers(q),
    queryFn: ({ signal }) => unwrap(api.GET('/employers', { params: { query: { q, size: 20 } }, signal })),
    staleTime: STALE.list,
    placeholderData: keepPreviousData,
  });

export const importCategoriesQuery = (bankId: string) =>
  queryOptions({
    queryKey: importKeys.categories(bankId),
    queryFn: ({ signal }) => unwrap(api.GET('/banks/{bankId}/employer-categories', { params: { path: { bankId } }, signal })),
    staleTime: STALE.reference,
  });
